import { render, staticRenderFns } from "./DefaultEventGrid.vue?vue&type=template&id=7b12f3e0&lang=pug"
import script from "./DefaultEventGrid.vue?vue&type=script&lang=js"
export * from "./DefaultEventGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports